import styled from "styled-components";
import { useEffect, useState } from "react";

import * as css from "styles/CssVariables.js";

import sadIcon from "assets/img/icons/icons8-sad.svg";
import ButtonPrimary from "components/buttons/ButtonPrimary";
import SponsoredMessage from "components/posts/SponsoredMessage";

const TryAgain = styled.div`
  width: 100%;
  height: 400px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${css.VERTICAL_BOX_MARGIN_LARGE};
`;

const TryAgainBox = styled.div`
  width: 100%;
  max-width: 500px;
  padding: 40px 0;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 30px;
`;

const Title = styled.div`
  max-width: 370px;

  font-size: 30px;
  font-weight: 500;
  text-align: center;
`;

const SubTitle = styled.div`
  text-align: center;
`;

const IconTextWrap = styled.span`
  background-image: url(${sadIcon});
  background-position: 100% 100%;
  background-repeat: no-repeat;
  background-size: 34px 34px;
  padding-right: 35px;
`;

const ButtonWrap = styled.div``;

export default ({
  onTryAgainClick,
  sponsoredMessage,
  onSponsoredMessageClick,
}) => {
  const [counter, setCounter] = useState(9);

  useEffect(() => {
    const interval = setInterval(() => {
      setCounter((prevCounter) => {
        const newCounter = prevCounter - 1;
        if (newCounter === 0) clearInterval(interval);
        return newCounter;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  let label = "Try Again";

  if (counter > 0) label += ` (${counter}s)`;

  // console.log("sponsoredMessage", sponsoredMessage);

  return (
    <TryAgain>
      <TryAgainBox>
        <Title>
          We didn't find any more posts for{" "}
          <IconTextWrap icon={sadIcon}>you</IconTextWrap>
        </Title>
        <SubTitle>Please try again or come back later.</SubTitle>
        <ButtonWrap>
          <ButtonPrimary onClick={onTryAgainClick} disabled={counter > 0}>
            {label}
          </ButtonPrimary>
        </ButtonWrap>
        {sponsoredMessage && (
          <SponsoredMessage
            profileImage={sponsoredMessage.user.profile_image}
            username={sponsoredMessage.user.username}
            checkmark={sponsoredMessage.user.ad_plan}
            text={sponsoredMessage.text}
            linkText={sponsoredMessage.link_text}
            link={sponsoredMessage.link}
            onLinkClick={onSponsoredMessageClick}
          />
        )}
      </TryAgainBox>
    </TryAgain>
  );
};
